var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-input-number", {
        staticClass: "item",
        attrs: {
          type: "text",
          size: "small",
          disabled: _vm.disabled,
          precision: _vm.precision,
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
        },
        on: { change: _vm.input },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
      _vm.errorSign
        ? _c(
            "el-tooltip",
            {
              staticClass: "right",
              attrs: { effect: "dark", content: _vm.message, placement: "top" },
            },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red", "line-height": "32px" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }